import { Link } from "react-router-dom";
import { CityPage, FAQ, CityProduct } from "./CityPage";
import { URLS } from "../../adds/product-links";

const products: CityProduct[] = [
  {
    title: "Fietsbril",
    description:
      "Op de route naar Zandvoort en Bloemendaal waait er vaak zand en stof. Een fietsbril houdt je zicht helder.",
    url: URLS.sunglasses,
  },
  {
    title: "Regenjas voor op de fiets",
    description:
      "Kustweer in Haarlem kan zomaar omslaan. Een waterdichte fietsjas is snel terugverdiend.",
    url: URLS.raincoat,
  },
  {
    title: "Fietspomp",
    description:
      "Handig voor langere tochten zoals Haarlem naar Amsterdam, Leiden of langs de kust.",
    url: URLS.pump,
  },
];

const faqs: FAQ[] = [
  {
    question: "Staat er altijd veel wind in Haarlem?",
    answer:
      "Haarlem ligt vlak bij de Noordzeekust. Daardoor is er vaak meer wind dan in steden verder landinwaarts, vooral bij zuidwestelijke en westelijke wind. In najaar en winter kan de wind dagenlang aanhouden.",
  },
  {
    question: "Is fietsen van Haarlem naar Zandvoort zwaar?",
    answer:
      "De ~10 km rit door de duinen kan bij stevige westenwind op de heenweg flink tegenvallen, omdat je dan tegen de zeewind in fietst. Op de terugweg heb je meestal juist wind mee.",
  },
  {
    question: "Welke kant komt de wind in Haarlem vandaan?",
    answer:
      "Overheersend zuidwest, recht vanaf zee. Routes richting Amsterdam of Spaarndam hebben daardoor vaak wind in de rug, terwijl ritjes naar het zuiden (bijvoorbeeld Leiden) eerder tegenwind opleveren.",
  },
];

export function Haarlem() {
  return (
    <CityPage
      city="Haarlem"
      title="Fietsweer Haarlem | Heb ik tegenwind?"
      description="Plan je fietstocht in Haarlem en omgeving. Check de windrichting, tegenwind en meewind voor jouw route, of je nu naar Zandvoort, Amsterdam of door de stad fietst."
      path="/fietsweer/haarlem"
      faqs={faqs}
      products={products}
    >
      <p>
        Haarlem ligt op een steenworp afstand van de Noordzee, wat voor
        fietsers betekent dat de wind hier vrijwel altijd een rol speelt. Of je
        nu naar Zandvoort naar het strand fietst, pendelt naar Amsterdam of
        door het open polderland rondom de stad toert: met de fietsweer-tool
        weet je vooraf of je tegenwind, meewind of zijwind krijgt.
      </p>

      <h3>Wind in Haarlem: altijd dichtbij de kust</h3>
      <p>
        De overheersende windrichting in Haarlem is zuidwest, recht vanaf zee.
        Dat maakt de korte route naar Zandvoort of Bloemendaal berucht:
        richting het strand vaak stevige zijwind, op de terugweg vaak meewind.
        In het najaar en de winter kan de wind vanaf zee fors zijn, ga voor
        lange ritjes daarom goed voorbereid op pad.
      </p>

      <h3>Populaire fietsroutes in Haarlem</h3>
      <ul>
        <li>
          <strong>Haarlem naar Zandvoort:</strong> klassieker voor een
          stranddag, zo'n 10 km door de duinen. Vooral bij westenwind een flink
          zwoegwerk op de heenweg.
        </li>
        <li>
          <strong>Haarlem naar Amsterdam:</strong> populaire forenzenroute via
          de Haarlemmertrekvaart of over de Haarlemmerweg, ongeveer 20 km.
        </li>
        <li>
          <strong>Haarlem naar Spaarndam:</strong> korte rit langs het Spaarne,
          rustig en pittoresk.
        </li>
        <li>
          <strong>Haarlem naar Bloemendaal en Overveen:</strong> via de duinen
          en de Elswoutlaan, met veel beschutting in het bos.
        </li>
        <li>
          <strong>Haarlem naar Leiden:</strong> langere rit van zo'n 35 km,
          grotendeels door open polderland.
        </li>
      </ul>

      <h3>Check de wind voor jouw Haarlemse rit</h3>
      <p>
        Vul jouw startpunt en bestemming in op de{" "}
        <Link to="/">fietsweer-tool</Link> en zie direct hoeveel procent van je
        route je tegenwind, meewind of zijwind hebt. Handig of je nu even naar
        het strand gaat of een hele dag op de fiets zit.
      </p>

      <h3>Meer lezen</h3>
      <ul>
        <li>
          <Link to="/tegenwind-tips">Hoe fiets je effectief tegen de wind in</Link>
        </li>
        <li>
          <Link to="/fietsweer/amsterdam">Fietsweer Amsterdam</Link>
        </li>
        <li>
          <Link to="/onstaan-van-wind">Hoe ontstaat wind?</Link>
        </li>
      </ul>
    </CityPage>
  );
}
